(function () {
  "use strict";

  const FORM_ID = "RVCu5C";
  const PROPERTY_NAME = "JB Shopping Preference";
  const SUCCESS_CTA_SELECTOR = ".jb-preference-shop-cta";
  const HEADER_SELECTOR = ".jb-preference-email-header";
  const COPY_SELECTOR = ".jb-preference-email-copy";
  const IMAGE_SELECTOR = 'img[alt="Janela Bay swimwear selected for you"]';

  const EXPERIENCES = Object.freeze({
    women_modest_swim: Object.freeze({
      kicker: "Women’s Modest Swim",
      destinationLabel: "women’s swim",
      ctaLabel: "Shop Women’s Swim",
      route: "/collections/womens-swim",
      image:
        "https://d3k81ch9hvuctc.cloudfront.net/company/RALrSs/images/092531fb-a5e1-4400-bb19-66658907500e.jpeg",
    }),
    mix_match_tankinis: Object.freeze({
      kicker: "Mix & Match Swim",
      destinationLabel: "mix and match swim",
      ctaLabel: "Shop Mix & Match",
      route: "/pages/mix-and-match-swimwear",
      image:
        "https://d3k81ch9hvuctc.cloudfront.net/company/RALrSs/images/235982f1-acc7-49fd-9b91-192e00c461fb.jpeg",
    }),
    girls_modest_swim: Object.freeze({
      kicker: "Girls’ Modest Swim",
      destinationLabel: "girls’ swim",
      ctaLabel: "Shop Girls’ Swim",
      route: "/collections/girls-swim",
      image:
        "https://d3k81ch9hvuctc.cloudfront.net/company/RALrSs/images/7165b040-8a08-4ffd-9857-964ba37529f2.jpeg",
    }),
    family_swim: Object.freeze({
      kicker: "Family Swim",
      destinationLabel: "family swim",
      ctaLabel: "Shop Family Swim",
      route: "/pages/family-swim",
      image:
        "https://d3k81ch9hvuctc.cloudfront.net/company/RALrSs/images/b5a6ba05-dfc3-45f6-ad26-cf04fbbd37de.jpeg",
    }),
  });

  let selectedPreference = "";
  let formObserver = null;
  let updateQueued = false;

  function getFormId(detail) {
    return detail?.formId || detail?.formID || "";
  }

  function getSubmittedPreference(detail) {
    return (
      [
        detail?.metaData?.[PROPERTY_NAME],
        detail?.metaData?.properties?.[PROPERTY_NAME],
        detail?.metaData?.fields?.[PROPERTY_NAME],
        detail?.profile?.[PROPERTY_NAME],
        detail?.profile?.properties?.[PROPERTY_NAME],
        detail?.fields?.[PROPERTY_NAME],
      ].find(
        (value) =>
          typeof value === "string" &&
          Object.prototype.hasOwnProperty.call(EXPERIENCES, value),
      ) || ""
    );
  }

  function setText(target, value) {
    if (target && target.textContent !== value) {
      target.textContent = value;
    }
  }

  function applyExperience() {
    updateQueued = false;

    const experience = EXPERIENCES[selectedPreference];
    if (!experience) return;

    document.querySelectorAll(HEADER_SELECTOR).forEach((block) => {
      setText(block.querySelector("p:first-child"), experience.kicker);
    });

    const copy =
      "Enter your email and we’ll send your 10% off code. " +
      `Then continue straight to ${experience.destinationLabel}.`;

    document.querySelectorAll(COPY_SELECTOR).forEach((block) => {
      setText(block.querySelector("p") || block, copy);
    });

    document.querySelectorAll(IMAGE_SELECTOR).forEach((image) => {
      if (image.getAttribute("src") !== experience.image) {
        image.setAttribute("src", experience.image);
      }
      image.setAttribute("srcset", experience.image);
    });

    document.querySelectorAll(SUCCESS_CTA_SELECTOR).forEach((block) => {
      const link = block.matches("a") ? block : block.querySelector("a");
      const labelTarget =
        block.matches("a, button")
          ? block
          : link || block.querySelector("button, span") || block;
      setText(labelTarget, experience.ctaLabel);
      if (link) {
        link.setAttribute("href", experience.route);
      }
    });
  }

  function queueExperienceUpdate() {
    if (updateQueued || !selectedPreference) return;
    updateQueued = true;
    window.requestAnimationFrame(applyExperience);
  }

  function stopObservingForm() {
    if (formObserver) {
      formObserver.disconnect();
      formObserver = null;
    }
  }

  function observeForm() {
    if (!selectedPreference) return;

    if (!formObserver) {
      formObserver = new MutationObserver(queueExperienceUpdate);
      formObserver.observe(document.body, {
        childList: true,
        subtree: true,
      });
    }

    queueExperienceUpdate();
  }

  window.addEventListener("klaviyoForms", function (event) {
    const detail = event.detail || {};
    if (getFormId(detail) !== FORM_ID) return;

    if (detail.type === "open" || detail.type === "close") {
      selectedPreference = "";
      stopObservingForm();
      return;
    }

    if (detail.type !== "stepSubmit" && detail.type !== "submit") return;

    const submittedPreference = getSubmittedPreference(detail);
    if (submittedPreference) {
      selectedPreference = submittedPreference;
    }

    observeForm();
  });

  document.addEventListener(
    "click",
    function (event) {
      const cta =
        event.target instanceof Element
          ? event.target.closest(SUCCESS_CTA_SELECTOR)
          : null;

      if (
        event.defaultPrevented ||
        event.button !== 0 ||
        event.metaKey ||
        event.ctrlKey ||
        event.shiftKey ||
        event.altKey ||
        !cta
      ) {
        return;
      }

      const destination = EXPERIENCES[selectedPreference]?.route;
      if (!destination) return;

      event.preventDefault();
      event.stopPropagation();
      window.location.assign(destination);
    },
    true,
  );
})();

// The email-first YAxQSQ form has an optional native preference step. Keep its
// routing separate so the original RVCu5C experience above remains unchanged.
(function () {
  "use strict";

  const FORM_ID = "YAxQSQ";
  const FORM_SELECTOR = '[data-testid="klaviyo-form-YAxQSQ"]';
  const PROPERTY_NAME = "JB Shopping Preference";
  const ROUTES = Object.freeze({
    women_modest_swim: { label: "Shop Women’s Swim", path: "/collections/womens-swim" },
    mix_match_tankinis: { label: "Shop Mix & Match", path: "/pages/mix-and-match-swimwear" },
    girls_modest_swim: { label: "Shop Girls’ Swim", path: "/collections/girls-swim" },
    family_swim: { label: "Shop Family Swim", path: "/pages/family-swim" },
  });

  let preference = "";
  let observer = null;
  let observedPopup = null;
  let updateQueued = false;

  function fromEvent(detail) {
    return [
      detail?.metaData?.[PROPERTY_NAME],
      detail?.metaData?.properties?.[PROPERTY_NAME],
      detail?.metaData?.fields?.[PROPERTY_NAME],
      detail?.profile?.properties?.[PROPERTY_NAME],
      detail?.fields?.[PROPERTY_NAME],
    ].find((value) => typeof value === "string" && ROUTES[value]) || "";
  }

  function updateCta() {
    updateQueued = false;
    const route = ROUTES[preference];
    const form = document.querySelector(FORM_SELECTOR);
    if (!route || !form) return;

    form.querySelectorAll("a, button").forEach((control) => {
      if (
        control.dataset.jbPreferenceRoute !== "true" &&
        !/^explore janela bay$/i.test(control.textContent.trim())
      ) return;

      const walker = document.createTreeWalker(control, NodeFilter.SHOW_TEXT);
      let textNode;
      while ((textNode = walker.nextNode())) {
        if (/^explore janela bay$/i.test(textNode.nodeValue.trim()) ||
            /^shop (women’s swim|mix & match|girls’ swim|family swim)$/i.test(textNode.nodeValue.trim())) {
          textNode.nodeValue = route.label;
          break;
        }
      }
      if (control.hasAttribute("aria-label")) control.setAttribute("aria-label", route.label);
      if (control.matches("a")) control.setAttribute("href", route.path);
      control.dataset.jbPreferenceRoute = "true";
    });
  }

  function queueUpdate() {
    if (!preference || updateQueued) return;
    updateQueued = true;
    window.requestAnimationFrame(updateCta);
  }

  function stopObserving() {
    observer?.disconnect();
    observer = null;
    observedPopup = null;
  }

  function observePopup() {
    if (!preference) return;
    const dialog = document.querySelector('[role="dialog"]:has(' + FORM_SELECTOR + ')');
    const popupRoot = dialog?.parentElement || dialog;
    if (popupRoot && popupRoot !== observedPopup) {
      stopObserving();
      observer = new MutationObserver(queueUpdate);
      observer.observe(popupRoot, { childList: true, subtree: true });
      observedPopup = popupRoot;
    }
    queueUpdate();
  }

  window.addEventListener("klaviyoForms", (event) => {
    const detail = event.detail || {};
    if ((detail.formId || detail.formID) !== FORM_ID) return;
    if (detail.type === "open" || detail.type === "close") {
      preference = "";
      stopObserving();
      return;
    }
    if (detail.type !== "stepSubmit" && detail.type !== "submit") return;
    preference = fromEvent(detail) || preference;
    observePopup();
  });

  document.addEventListener("change", (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || input.type !== "radio" ||
        !input.closest(FORM_SELECTOR) || !ROUTES[input.value]) return;
    preference = input.value;
    observePopup();
  }, true);

  document.addEventListener("click", (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const control = target.closest("a, button");
    if (!control?.closest(FORM_SELECTOR)) return;

    if (/^skip for now$/i.test(control.textContent.trim())) {
      preference = "";
      stopObserving();
      return;
    }

    const route = ROUTES[preference];
    if (!route || event.defaultPrevented || event.button !== 0 ||
        event.metaKey || event.ctrlKey || event.shiftKey || event.altKey ||
        (control.dataset.jbPreferenceRoute !== "true" &&
         !/^explore janela bay$/i.test(control.textContent.trim()))) return;

    event.preventDefault();
    event.stopPropagation();
    window.location.assign(route.path);
  }, true);
})();
